import type { JSX } from 'react'

export const RewindLeftIcon = (): JSX.Element => (
  <use href='#rewindLeftIcon' height='100%' width='100%' />
)
